import { useState } from "react";
import NewTabElements from "../../../components/newTabElements/newTabElements";
import { DraftSubmission } from "../../../data-model/draftSubmission";
import { onTabChange } from "../actionHandlers/draftSubmissionTabsHandlers";

interface DraftSubmissionTabsProps {
  draftSubmissions: DraftSubmission[];
  activeAuthId?: (authId: string) => void;
}

const DraftSubmissionTabs = (props: DraftSubmissionTabsProps) => {
  const [activeTab, setActiveTab] = useState(
    props.draftSubmissions[0]?.id ?? "",
  );
  const tabs = props.draftSubmissions.map((draftSubmission) => ({
    id: draftSubmission.id ?? "",
    label: draftSubmission.payer_portal ?? "",
  }));

  return (
    <div className="draft-submission-tabs--container flex flex-row gap-2">
      <NewTabElements
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={(tab) =>
          onTabChange(tab, setActiveTab, props.activeAuthId)
        }
        className="rounded-t"
      />
    </div>
  );
};

export default DraftSubmissionTabs;
